var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.block)?_c('h' + _vm.block.attrs.level,{tag:"component",class:{
			['color-' + _vm.block.attrs.textColor]: true,
			[_vm.block.attrs.fontSize]: true,
			[_vm.block.attrs.className
				? _vm.block.attrs.className
				: 'no-style']: true
		},domProps:{"innerHTML":_vm._s(_vm.block.attrs.text)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }